export const sortFeeSchedules = ( feeSchedules = []) => {

  const topTier = feeSchedules.filter((f) => f.breakpoint === null);
  const sortedList = feeSchedules
    .filter((f) => f.breakpoint !== null)
    .sort((a, b) => {
      return Number(a.breakpoint) - Number(b.breakpoint);
    });
  return [...sortedList, ...topTier];
};

export const generateInternalFeeId = (length = 5) => {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

// These functions exist for backwards compatibility.

export const toUpperBounded = (schedules) => {
  return schedules.map(
    ({ breakpoint, rate }, index) => {
      const upperBound = (
        index + 1 < schedules.length
          ? schedules[index + 1].breakpoint
          : null
      );
      return { id: upperBound, breakpoint: upperBound, rate };
    }
  );
}

export const toLowerBounded = (schedules) => {
  return schedules.map(
    ({ breakpoint, rate }, index) => {
      const lowerBound = (
        index > 0
          ? schedules[index - 1].breakpoint
          : 0
      );
      return { breakpoint: lowerBound, rate };
    }
  );
}



// WEBPACK FOOTER //
// ./src/containers/Cy/components/TieredFeeDataBox/helper.js